import { render } from "./carParts.vue?vue&type=template&id=0ca8c58f&scoped=true"
import script from "./carParts.vue?vue&type=script&lang=js"
export * from "./carParts.vue?vue&type=script&lang=js"

import "./carParts.vue?vue&type=style&index=0&id=0ca8c58f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca8c58f"]])

export default __exports__